export const actions = {
  GET_INSPECTIONS_BY_SHARED_LIST: 'GET_INSPECTIONS_BY_SHARED_LIST',
  GET_INSPECTIONS_BY_SHARED_LIST_SUCCESS: 'GET_INSPECTIONS_BY_SHARED_LIST_SUCCESS',
  GET_INSPECTIONS_BY_SHARED_LIST_FAILURE: 'GET_INSPECTIONS_BY_SHARED_LIST_FAILURE',
  SET_INSPECTIONS_BY_SHARED_PAGE: 'SET_INSPECTIONS_BY_SHARED_PAGE',
};
